import { useSettingDiscoverPageImprovements } from "@faire/deprecated-retailer-visitor-shared/settings/useSettingDiscoverPageImprovements";
// eslint-disable-next-line @faire/enforce-internal-folder-encapsulation
import { MAX_PRODUCTS_PER_FILTERED_SECTION } from "@faire/deprecated-retailer-visitor-shared/views/search-v2/__internal__/LazySearchPage/__internal__/SearchPage/__internal__/SearchPageHeaderAndResults/__internal__/DiscoverPageFilteredProductGrids/DiscoverPageFilteredProductGrids";
// eslint-disable-next-line @faire/enforce-internal-folder-encapsulation
import { useSearchPageSlicedProducts } from "@faire/deprecated-retailer-visitor-shared/views/search-v2/__internal__/LazySearchPage/__internal__/SearchPage/__internal__/useSearchPageSlicedProducts";
// eslint-disable-next-line @faire/enforce-internal-folder-encapsulation
import { useDiscoverPageFilteredProductGrids } from "@faire/deprecated-retailer-visitor-shared/views/search-v2/__internal__/LazySearchPage/__internal__/SearchPage/DataFetching/Products/useDiscoverPageFilteredProductGrids";
import { useSearchPageFilters } from "@faire/deprecated-retailer-visitor-shared/views/search-v2/SearchPageQueryParams/useSearchPageFilters";
import { useSearchPageZeroIndexedPageNumber } from "@faire/deprecated-retailer-visitor-shared/views/search-v2/SearchPageQueryParams/useSearchPageZeroIndexedPageNumber";
import { useSettingDiscoverPageSectionalDesign } from "@faire/retailer-visitor-shared/settings/useSettingDiscoverPageSectionalDesign";
import { useResponsiveValue } from "@faire/web/ui/hooks/useResponsiveValue";

export const useDiscoverPageShouldShowTopProducts = () => {
  const queryProducts = useSearchPageSlicedProducts();
  const page = useSearchPageZeroIndexedPageNumber();
  const filters = useSearchPageFilters();
  const { filteredProductGrids } = useDiscoverPageFilteredProductGrids();
  const discoverPageSectionalDesignV2 = useSettingDiscoverPageSectionalDesign();
  const itemsPerFilteredSection = useResponsiveValue(
    MAX_PRODUCTS_PER_FILTERED_SECTION
  );
  const isDiscoverPageImprovements = useSettingDiscoverPageImprovements();
  return (
    discoverPageSectionalDesignV2 &&
    isDiscoverPageImprovements &&
    (queryProducts?.length ?? 0) > itemsPerFilteredSection &&
    page === 0 &&
    filters.length === 0 &&
    filteredProductGrids.length > 0
  );
};
